










































import { Prop, Watch } from "vue-property-decorator";
import { Component } from "vue-mixin-decorator";
import { HtmlOptionInfo } from "@/@types/window";
import SelectMixin from "@/app/basic/common/components/select/base/SelectMixin";
import VueEvent from "@/app/core/decorator/VueEvent";
import { createRectangle } from "@/app/core/utility/CoordinateUtility";
import { Rectangle } from "address";

@Component
export default class CtrlSelect extends SelectMixin {
  @Prop({ type: Array, required: true })
  private optionInfoList!: HtmlOptionInfo[];

  @Prop({ type: Number, default: 0 })
  private maxWidth!: number;

  private fontColor: string = "";

  public focus(): void {
    const elm: HTMLSelectElement = this.$refs.component as HTMLSelectElement;
    elm.focus();
  }

  public getRect(): Rectangle {
    const elm: HTMLSelectElement = this.$refs.component as HTMLSelectElement;
    const r = elm.getBoundingClientRect();
    return createRectangle(r.x, r.y, r.width, r.height);
  }

  @VueEvent
  private onDblClick() {
    if (!this.multiple) return;
    this.localValue = [];
  }

  @Watch("optionInfoList", { immediate: true })
  onChangeOptionInfoList() {
    if (this["test"]) {
      window.console.log(this.optionInfoList);
    }
  }

  @Watch("value", { immediate: true })
  onChangeValue(value: string | string[]) {
    const optionInfo: HtmlOptionInfo = this.optionInfoList.filter(
      optionInfo => {
        if (typeof value === "string") return optionInfo.value === value;
        else return value.findIndex(v => v === optionInfo.value) > -1;
      }
    )[0];
    this.fontColor = optionInfo && optionInfo.disabled ? "#999999" : "#000000";
  }
}
